import { OFFER_STATUS, VALIDATION_STATUS, OFFER_TYPE } from '@/helpers/constants'
import {
  getUpdatedProductListOnDiscountChange,
  getUpdatedProductListOnPriceChange,
  getUpdatedProductListOnLimitChange,
} from '@/helpers/productListHelpers/getUpdatedProductList'
import {
  getDiscountedPrice,
  getCommittedDeliveriesForProduct,
} from '@/helpers/productListHelpers/productListGetters'

export const SET_OFFER = 'SET_OFFER'
export const SET_OFFER_ITEM = 'SET_OFFER_ITEM'
export const SET_OFFER_PRODUCT_SELECTION = 'SET_OFFER_PRODUCT_SELECTION'
export const SET_OFFER_PAYMENT_METHOD_SELECTION = 'SET_OFFER_PAYMENT_METHOD_SELECTION'
export const SET_OFFER_ADDITIONAL_SERVICE = 'SET_OFFER_ADDITIONAL_SERVICE'
export const SET_OFFER_BASEPRICE_ITEM = 'SET_OFFER_BASEPRICE_ITEM'
export const SET_OFFER_PRODUCT_ITEM = 'SET_OFFER_PRODUCT_ITEM'
export const SET_OFFER_STANDARD_WEIGHT_LIST = 'SET_OFFER_STANDARD_WEIGHT_LIST'
export const SET_OFFER_DISCOUNT = 'SET_OFFER_DISCOUNT'
export const SET_PACKAGE_ITEM = 'SET_PACKAGE_ITEM'
export const SET_OFFER_PAYMENT_DAY = 'SET_OFFER_PAYMENT_DAY'
export const SET_OFFER_DISPERSION = 'SET_OFFER_DISPERSION'
export const SET_SERVICE_POINT_SHIPMENTS = 'SET_SERVICE_POINT_SHIPMENTS'
export const SET_FAV_SERVICE_POINT = 'SET_FAV_SERVICE_POINT'
export const SET_TARIFF_MODEL = 'SET_TARIFF_MODEL'
export const SET_LEGAL_CITY = 'SET_LEGAL_CITY'
export const SET_B2B_DISTRIBUTION = 'SET_B2B_DISTRIBUTION'
export const SET_B2C_DISTRIBUTION = 'SET_B2C_DISTRIBUTION'
export const SET_TYPE_AND_VAL_STATUS_OFFER = 'SET_TYPE_AND_VAL_STATUS_OFFER'
export const UPDATE_PRODUCT_DISCOUNT = 'UPDATE_PRODUCT_DISCOUNT'
export const UPDATE_PRODUCT_ZONE_KG_PRICE = 'UPDATE_PRODUCT_ZONE_KG_PRICE'
export const SET_ALL_DISCOUNTS_OF_PRODUCT = 'SET_ALL_DISCOUNTS_OF_PRODUCT'
export const SET_PRODUCT_CURRENT_WEIGHT_LIST = 'SET_PRODUCT_CURRENT_WEIGHT_LIST'
export const UPDATE_PRODUCT_BASE_PRICES = 'UPDATE_PRODUCT_BASE_PRICES'
export const RESET_VALIDATED_OFFER_STATUS = 'RESET_VALIDATED_OFFER_STATUS'
export const SET_BANK_GUARANTEE_AMOUNT = 'SET_BANK_GUARANTEE_AMOUNT'
export const SET_BANK_GUARANTEE_TYPE = 'SET_BANK_GUARANTEE_TYPE'
export const SET_BANK_GUARANTEE_DURATION = 'SET_BANK_GUARANTEE_DURATION'

export default {
  /**
   *
   * @param state
   * @param payload
   */
  [SET_OFFER](state, payload) {
    state.offer = {
      ...state.offer,
      ...payload,
    }

    this.commit('process/setSignStatus', state.offer, { root: true })

    const productList = state.offer.productList.map(obj => ({
      ...obj,
    }))

    const nationalDeliveries = Number(state.offer.clientCommitedDeliveries)
    const internationalDeliveries = state.offer.internationalShipments

    /** Si se entra sin cambiar nada, rellena basePrices con los valores por defecto */
    for (let product = 0; product < productList.length; product++) {
      let zoneList = productList[product].zoneList
      let selectedWeights = productList[product].currentWeightIdList
      // Volumen comprometido según el ámbito del producto (internacional vs nacional)
      const commitedDeliveries = Number(
        getCommittedDeliveriesForProduct(
          productList[product],
          nationalDeliveries,
          internationalDeliveries,
        ),
      )
      for (let zone = 0; zone < zoneList.length; zone++) {
        if (zoneList[zone].basePrices.length === 0) {
          // Aquí es cuando están vacíos
          let discounts = productList[product].zoneList[zone].discounts.filter(
            discount => discount.shippingUntil >= commitedDeliveries,
          )
          let filteredDiscounts = 1 - discounts[0].stdDiscountRate
          let auxDefaultPrices = zoneList[zone].defaultPrices
            .filter(element => selectedWeights.includes(element.id))
            .map(price => ({
              id: price.id,
              price: Number((price.price * filteredDiscounts).toFixed(2)),
            }))
          zoneList[zone].basePrices = auxDefaultPrices
          zoneList[zone].additionalKgValue = Number(
            (Number(zoneList[zone].additionalKgValue) * filteredDiscounts).toFixed(2),
          )

          // También hay que modificar los kg adicionales con el descuento.
        } else {
          // for (let price = 0; price < zoneList[zone].defaultPrices.length; price++) {
          // const id = zoneList[zone].defaultPrices[price].id
          // const basePrice = zoneList[zone].basePrices.find(element => element.id === id)
          // if (basePrice) {
          //   zoneList[zone].defaultPrices[price] = { ...basePrice }
          // }
          // }
        }
      }
    }
  },

  /**
   *
   * @param state
   * @param payload ({name, value}
   */
  [SET_OFFER_ITEM](state, payload) {
    payload.forEach(item => {
      state.offer[item.name] = item.value
    })
  },
  /**
   *
   * @param state
   * @param payload ({name, value}
   */
  [SET_OFFER_PRODUCT_ITEM](state, payload) {
    payload.forEach(item => {
      state.offer.productList[item.name].currentWeightIdList = item.value
    })
  },

  /**
   *
   * @param state
   * @param payload ({name, value}
   */
  [SET_OFFER_PRODUCT_SELECTION](state, payload) {
    state.offer.productList.forEach(item => {
      item.isPreSelected = false
    })
    payload.ids.forEach(item => {
      for (let product of state.offer.productList) {
        if (product.id === item) {
          product.isPreSelected = true
        }
      }
    })
  },

  /**
   *
   * @param state
   * @param payload ({id})
   */
  [SET_OFFER_PAYMENT_METHOD_SELECTION](state, payload) {
    for (let paymentMethod of state.offer.paymentMethods) {
      if (paymentMethod.id === payload.id) {
        paymentMethod.isSelected = true
      } else {
        paymentMethod.isSelected = false
      }
    }
  },

  /**
   *
   * @param state
   * @param payload ({day})
   */
  [SET_OFFER_PAYMENT_DAY](state, payload) {
    state.offer.additionalServices.paymentDay = payload.day
  },

  /**
   *
   * @param state
   * @param updatedService
   */
  [SET_OFFER_ADDITIONAL_SERVICE](state, updatedService) {
    const indexEditedService = state.offer.extraServicesList.findIndex(
      serv => serv.id === updatedService.id,
    )
    const newServices = [
      ...state.offer.extraServicesList.slice(0, indexEditedService),
      updatedService,
      ...state.offer.extraServicesList.slice(indexEditedService + 1),
    ]
    state.offer.extraServicesList = newServices
  },

  /**
   *
   * @param state
   * @param payload ({name, value}
   */
  [SET_PACKAGE_ITEM](state, payload) {
    const possibleFields = [
      'packageAmount',
      'goodTypes',
      'numberShipmentRepayments',
      'meanRepaymentValue',
      'typeOfPackages',
      'pickupDays',
      'observations',
    ]
    possibleFields.forEach(field => {
      if (field in payload) {
        state.offer.additionalServices[field] = payload[field]
      }
    })
  },

  /**
   *
   * @param state
   * @param payload ({name, value}
   */
  [SET_OFFER_BASEPRICE_ITEM](state, payload) {
    const { productList } = state.offer
    const { productIndex, zoneIndex, value } = payload.newData
    const selectedItems = productList.filter(
      product => product.isMandatory || product.isPreSelected,
    )
    selectedItems[productIndex].zoneList[zoneIndex].basePrices = value
  },

  /**
   *
   * @param state
   * @param payload ({name, value}
   */
  [SET_OFFER_STANDARD_WEIGHT_LIST](state, payload) {
    const { productList } = state.offer
    const { productIndex, value } = payload.newData

    productList[productIndex].currentWeightIdList = value
  },

  /**
   *
   * @param state
   * @param payload ({name, value}
   */
  [SET_OFFER_DISCOUNT](state, payload) {
    const { productList } = state.offer
    const { productIndex, zoneIndex, additionalWeights, value } = payload.newData
    const selectedItems = productList.filter(
      product => product.isMandatory || product.isPreSelected,
    )
    const zone = selectedItems[productIndex].zoneList[zoneIndex]
    zone.additionalKgValue = additionalWeights
    zone.amountOutOfDiscount = value
  },

  /**
   *
   * @param state
   * @param payload ({name, value}
   */
  [SET_OFFER_DISPERSION](state, payload) {
    const { productList } = state.offer
    const { productIndex, productDispersion, zoneDispersion } = payload.dispersion
    productList[productIndex].dispersionRateByProduct = productDispersion
    for (let zone = 0; zone < productList[productIndex].zoneList.length; zone++) {
      productList[productIndex].zoneList[zone].dispersionRateByZone = zoneDispersion[zone]
    }
  },

  /**
   *
   * @param state
   * @param {object} payload ({servicePointExtId, compromisedShipments})
   */
  [SET_SERVICE_POINT_SHIPMENTS](state, { servicePointExtId, compromisedShipments }) {
    const i = state.offer.optyServicePoints.findIndex(
      obj => obj.servicePointExtId === servicePointExtId,
    )
    state.offer.optyServicePoints[i].compromisedShipments = Number(compromisedShipments)
  },

  /**
   *
   * @param state
   * @param {string} servicePointExtId
   */
  [SET_FAV_SERVICE_POINT](state, servicePointExtId) {
    state.offer.optyServicePoints = state.offer.optyServicePoints.map(servicePoint => {
      if (servicePoint.servicePointExtId === servicePointExtId) servicePoint.isFavorite = true
      else servicePoint.isFavorite = false
      return servicePoint
    })
  },

  /**
   *
   * @param state
   * @param {number} rateModelId
   */
  [SET_TARIFF_MODEL](state, rateModelId) {
    state.offer.rateModelId = rateModelId
  },

  /**
   *
   * @param state
   * @param {String} legalCity
   */
  [SET_LEGAL_CITY](state, legalCity) {
    state.offer.legalCity = legalCity
  },

  /**
   *
   * @param state
   * @param {number} b2bPercentage
   */
  [SET_B2B_DISTRIBUTION](state, b2bPercentage) {
    state.offer.b2b = b2bPercentage
  },

  /**
   *
   * @param state
   * @param {number} b2cPercentage
   */
  [SET_B2C_DISTRIBUTION](state, b2cPercentage) {
    state.offer.b2c = b2cPercentage
  },

  /**
   * @param state
   * @param payload
   * @param {String} payload.type - Enum: OFFER_TYPE
   */
  [SET_TYPE_AND_VAL_STATUS_OFFER](state, payload) {
    state.offer.type = payload.type

    const newValidationStatusValue =
      payload.type === OFFER_TYPE.A ? VALIDATION_STATUS.APPROVED : VALIDATION_STATUS.PENDING
    state.offer.validationStatus = newValidationStatusValue

    if (state.offer.status === OFFER_STATUS.VALIDATED) {
      state.offer.status = OFFER_STATUS.EDITED
    }
  },

  /**
   * @param state
   * @param {String} payload.productId
   * @param {String} payload.zoneId
   * @param {number} payload.discount
   */
  [UPDATE_PRODUCT_DISCOUNT](state, payload) {
    const { productId, zoneId, discount } = payload
    state.offer.productList = getUpdatedProductListOnDiscountChange(
      state.offer.productList,
      productId,
      zoneId,
      discount,
    )
  },

  /**
   * @param state
   * @param {String} payload.productId
   * @param {number} payload.weight
   * @param {String} payload.zoneId
   * @param {number} payload.price
   */
  [UPDATE_PRODUCT_ZONE_KG_PRICE](state, payload) {
    const { productId, weight, zoneId, price, typeKg } = payload
    state.offer.productList = getUpdatedProductListOnPriceChange(
      state.offer.productList,
      productId,
      weight,
      zoneId,
      price,
      typeKg,
    )
  },

  /**
   * @param state
   * @param {String} payload.productId
   * @param {String} payload.discountRates
   */
  [SET_ALL_DISCOUNTS_OF_PRODUCT](state, payload) {
    const { productId, discountRates } = payload
    state.offer.productList = getUpdatedProductListOnLimitChange(
      state.offer.productList,
      productId,
      discountRates,
    )
  },

  /**
   * @param state
   * @param {Object} payload
   * @param {string} payload.productIndex
   * @param {Array} payload.weightList - array of weights (numbers)
   */
  [SET_PRODUCT_CURRENT_WEIGHT_LIST](state, payload) {
    const { productIndex, weightList } = payload
    state.offer.productList[productIndex].currentWeightIdList = weightList
  },

  /**
   * @param state
   * @param {Object} payload
   * @param {string} payload.productIndex
   * @param {Array} payload.weightList - array of weights (numbers)
   */
  [UPDATE_PRODUCT_BASE_PRICES](state, payload) {
    const { productIndex, weightList } = payload
    const zoneList = state.offer.productList[productIndex].zoneList
    const fixedPrice = state.offer.productList[productIndex].fixedPrice || 0

    for (let i = 0; i < zoneList.length; i++) {
      const weightFilteredDefaultPrices = zoneList[i].defaultPrices.filter(item =>
        weightList.includes(item.id),
      )
      const discount = zoneList[i].amountOutOfDiscount
      const weightFilteredBasePrices = weightFilteredDefaultPrices.map(item => ({
        ...item,
        price: getDiscountedPrice(item.price, discount, fixedPrice),
      }))
      zoneList[i].basePrices = weightFilteredBasePrices
    }
  },

  /**
   *
   * @param state
   */
  [RESET_VALIDATED_OFFER_STATUS](state) {
    if (state.offer.type !== OFFER_TYPE.A && state.offer.status === OFFER_STATUS.VALIDATED) {
      state.offer.status = OFFER_STATUS.EDITED
      state.offer.validationStatus = VALIDATION_STATUS.PENDING
    }
  },

  /**
   *
   * @param state
   * @param {Object} payload - Bank guarantee amount
   */
  [SET_BANK_GUARANTEE_AMOUNT](state, payload) {
    if (state.offer.bankGuarantee) {
      state.offer.bankGuarantee.amount = payload
    }
  },

  /**
   *
   * @param state
   * @param {Object} payload - Selected bank guarantee type key
   */
  [SET_BANK_GUARANTEE_TYPE](state, payload) {
    if (state.offer.bankGuarantee) {
      state.offer.bankGuarantee.types = state.offer.bankGuarantee.types.map(type => {
        const isSelected = type.key === payload
        return {
          key: type.key,
          isSelected,
        }
      })
    }
  },

  /**
   *
   * @param state
   * @param {Object} payload - Selected bank guarantee duration key
   */
  [SET_BANK_GUARANTEE_DURATION](state, payload) {
    if (state.offer.bankGuarantee) {
      state.offer.bankGuarantee.durations = state.offer.bankGuarantee.durations.map(type => {
        const isSelected = type.key === payload
        return {
          key: type.key,
          isSelected,
        }
      })
    }
  },
}
